import React, { useState, useEffect, useRef } from 'react'
import { 
    Layout,
    Col, 
    Row,
    Image,
    Button,
    Space,
    Table
} from 'antd';
import Navbar from '../../Components/Navbar/Navbar';
// import HeaderImage from '../../Assets/Images/CPM-HEADER-cropped-1.png'
import html2canvas from 'html2canvas';
import jsPDF from "jspdf";
// import TenantSignature from "../../Assets/Images/tenant_signature.png"
// import OwnerSignature from "../../Assets/Images/owner_signature.png"

import { useNavigate, useParams } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { useReactToPrint } from "react-to-print";
import { 
    ProductOutlined,
} from '@ant-design/icons';
import { SeeAttachment } from '../../Components/SeeAttachment';
import { formatAmount, formatDate, capitalizeText, refreshPage, extractDateTime } from '../../Utils/Common';
import { PreviewTable } from '../../Components/PreviewTable';

const PreviewBilling = () => {
    const navigate = useNavigate()
    const currentDate = new Date();
    const { id } = useParams();
    const [billingData, setBillingData] = useState([])
    const [billingAttachment, setBillingAttachment] = useState([]);
    const [newAttachment, setNewAttachment] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const { callPost, loading } = usePostRequest(()=>{
        refreshPage()
    });
    
    const handleSendEmail = async (ref) => {
        if (ref) {
            const element = document.getElementById(ref);
    
            html2canvas(element, { scale: 2 }).then(async (canvas) => {
                const scale = 0.7;
    
                // Create a new canvas with scaled dimensions
                const scaledCanvas = document.createElement('canvas');
                const context = scaledCanvas.getContext('2d');
                scaledCanvas.width = canvas.width * scale;
                scaledCanvas.height = canvas.height * scale;
    
                // Draw the original canvas onto the scaled canvas
                context.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, scaledCanvas.width, scaledCanvas.height);
    
                // Convert the scaled canvas to an image
                const imgData = scaledCanvas.toDataURL('image/jpeg', 1);
    
                const pdf = new jsPDF();
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = pdf.internal.pageSize.getHeight();
                const imgWidth = scaledCanvas.width;
                const imgHeight = scaledCanvas.height;
    
                // Calculate the ratio needed to fit the image within the PDF dimensions
                const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
    
                // Calculate the new width and height of the image
                const newWidth = imgWidth * ratio;
                const newHeight = imgHeight * ratio;
    
                // Center the image in the PDF
                const imgX = (pdfWidth - newWidth) / 2;
                const imgY = 0;
    
                // Add the image to the PDF
                pdf.addImage(imgData, 'JPEG', imgX, imgY, newWidth, newHeight); // Use 'JPEG' format for better compression
                pdf.save(`${billingData?.trade_name}_Billing_${extractDateTime(currentDate)}.pdf`);
    
                // Convert the pdf file from Blob to File obj (needed for upload API)
                const blobPdf = pdf.output('blob');
                const formPdf = new File([blobPdf], `${billingData?.trade_name}_Billing_${extractDateTime(currentDate)}.pdf`, {
                    type: blobPdf.type,
                });

                let file = [];

                if(newAttachment){
                    file = newAttachment.map((data) => {
                        return data?.file_url
                    });
                }
    
                const finalValues = Object.entries({ billing_id: id, attachment: formPdf, additional_attachments: file, filename: `${billingData?.trade_name}_Billing_${extractDateTime(currentDate)}.pdf` }).map(([key, value]) => ({
                    key,
                    value,
                }));
    
                callPost('emails/send_parking_billing', finalValues, true);
            });
        }
    };
    
    const columns = [
        {
            title: 'Billing No.',
            dataIndex: 'parking_billing_id',
            key: 'billing_id',
            align: 'center',
            width: '15%'
        },
        // {
        //     title: 'Billing Details No.',
        //     dataIndex: 'id',
        //     key: 'id',
        //     align: 'center',
        //     width: '17%'
        // },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            align: 'center',
            width: '50%',
            render: (description) => capitalizeText(description)
        },
        {
            title: 'Principal Amount',
            dataIndex: 'principal_amount',
            key: 'principal_amount',
            align: 'center',
            width: '50%',
            render: (description) => formatAmount(description)
        },
        {
            title: 'WHT',
            dataIndex: 'withholding_tax',
            key: 'wht',
            align: 'center',
            width: '50%',
            render: (description) => formatAmount(description)
        },
        {
            title: 'Discount',
            dataIndex: 'discount',
            key: 'discount',
            align: 'center',
            width: '50%',
            render: (description) => formatAmount(description)
        },
        {
            title: 'Amount Due',
            dataIndex: 'amount_due',
            key: 'amount_due',
            align: 'right',
            render: (amount) => formatAmount(amount),
            width: '25%'
        }
    ];
    

    const columns3 = [
        {
          title: 'Date Added',
          dataIndex: 'added_on',
          key: 'added_on',
          width: '30%',
          render: (amount) => formatDate(amount),
        },
        {
          title: 'Attachments',
          dataIndex: 'link',
          key: 'link',
        },
    ]; 

    async function fetchBillingData  () {
        setIsLoading(true)
        const response = await UseGetRequest("parking_billings/get_by_id", {parking_billing_id: id});
        if (response?.data) {
            
            let attachment = response?.data?.data?.attachments?.map((file) => ({
                ...file,
                link: (
                    <SeeAttachment
                    attachments={[
                        { file_url: file.file_url, file_name: file.file_name },
                    ]}
                    />
                ),
            }));

            let billing_attachment = response?.data?.data?.billing_attachments?.map((file) => ({
                ...file,
                link: (
                    <SeeAttachment
                    attachments={[
                        { file_url: file.file_url, file_name: file.file_name },
                    ]}
                    />
                ),
            }));

            setBillingAttachment(billing_attachment);
            setNewAttachment(attachment);
            setBillingData(response?.data?.data);
        } else {
          setBillingData([])
        }
        setIsLoading(false);
    }

    useEffect(() => {
        fetchBillingData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

    return (
        <Layout className='page'>
            <Navbar navKey={'property'}/>
            <Layout className='content-container content-container-print overflow-y'>
                <Row className='m-4 paper-view'>
                    <Col className='email-pad print-content' id="preview" ref={componentRef}>
                        <Row className='mb-5'>
                            <Col span={24} align="center">
                                <Image
                                    width='100%'
                                    height="90%"
                                    src={window.form_header}
                                    alt="login-image"
                                    preview={false}
                                />
                            </Col>
                        </Row>
                        <Row className='center mb-4'>
                            <Col className='divider-text'>
                                PARKING BILLING STATEMENT
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col span={16} align="left">
                                <Space>
                                    <div className='text-sm'>
                                       {billingData.type === "owner" ? "Owner Name :" : "Tenant Name :"}
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.trade_name}
                                    </div>
                                </Space>
                            </Col>
                            <Col span={8} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Billing No.
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.id}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col span={16} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Property :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.property_name}
                                    </div>
                                </Space>
                            </Col>
                            <Col span={8} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Parking Unit :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.parking_unit_name}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col span={16} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Address :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.address}
                                    </div>
                                </Space>
                            </Col>
                            <Col span={8} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Date.
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {formatDate(billingData?.added_on)}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col span={16}>
                                <Space>
                                    <div className='text-sm'>
                                        Period Covered :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {(billingData?.date_from !== "") && (billingData.date?.to !== "") ? formatDate(billingData?.date_from) + " - " +  formatDate(billingData?.date_to) : ""}
                                    </div>
                                </Space>
                            </Col>
                            <Col span={8}>
                                <Space>
                                    <div className='text-sm'>
                                        Due Date :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.due_date ? formatDate(billingData?.due_date): ""}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        {/* <Row className='mb-2'>
                            <Col span={18}>
                                <Space>
                                    <div>
                                        TIN :
                                    </div>
                                    <div className='bold-text'>
                                        {billingData?.tin}
                                    </div>
                                </Space>
                            </Col>
                            <Col span={6}>
                                <Row>
                                    
                                </Row>
                            </Col>
                        </Row> */}
                            
                        <Row gutter={[16, 16]} className='mb-4'>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='p-2 custom-table'>
                                {/* <Table
                                    dataSource={billingData?.details}
                                    columns={columns}
                                    rowKey="id"
                                    pagination={false}
                                /> */}
                                <PreviewTable
                                    dataSource={billingData?.details}
                                    columns={columns}
                                />
                            </Col>
                        </Row>
                        
                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                            
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} className='p-3 amount-total' align='right'>
                                Total: {formatAmount(billingData.grand_total)}
                            </Col>
                        </Row>
                        {
                            billingData?.remarks && (
                                <Row className='mb-2'>
                                    <Col span={18}>
                                        <Space>
                                            <div className='text-sm'>
                                                Remarks :
                                            </div>
                                            <div className='bold-text text-sm'>
                                                {billingData.remarks}
                                            </div>
                                        </Space>
                                    </Col>
                                    <Col span={6}>
                                        <Row>
                                            
                                        </Row>
                                    </Col>
                                </Row>
                            )
                        }
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} className='p-2'>
                                <Row>
                                    <Col className='text-sm'>
                                        Please make checks payable to:
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm mb-2'>
                                        {window.system_title}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm'>
                                        {window.account1}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm'>
                                        {window.account2}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm mb-2'>
                                        {window.account3}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm'>
                                        {window.account4}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm'>
                                        {window.account5}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm mb-2'>
                                        {window.account6}
                                    </Col>
                                </Row>
                                <Row className='my-5 text-sm'>
                                    <Col>
                                        Please advise if any payment made is not reflected in this statement.
                                    </Col>
                                </Row>
                                <Row className='my-4'>
                                    <Col align='left text-sm'>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                            {/* {
                                                billingData.type === "owner" ? (
                                                    <img
                                                    src={OwnerSignature}
                                                    alt="Owner Signature"
                                                    style={{ height:'10vh', margin: '0' }}
                                                    />
                                                ) : (
                                                    <img
                                                    src={TenantSignature}
                                                    alt="Tenant Signature"
                                                    style={{ height:'10vh', margin: '0' }}
                                                    />
                                                )
                                            } */}
                                            <div style={{ borderTop: '1px solid black', width: '150%', marginTop: '0', marginBottom: '0' }}></div>
                                            <div>Prepared By,</div>
                                        </div>
                                        {/* <Space direction='vertical' gutter={[0, 0]}>
                                            Prepared By,
                                            {
                                                billingData.type === "owner" ? (
                                                    <Image
                                                        src={OwnerSignature}
                                                        style={{height:'15vh', width: 'auto' }}
                                                        preview={false}
                                                    />
                                                ) : (
                                                    <Image
                                                        src={TenantSignature}
                                                        style={{height:'10vh', width: 'auto' }}
                                                        preview={false}
                                                    />
                                                )
                                            }
                                            __________________________
                                        </Space> */}
                                    </Col>
                                </Row>
                               <Row>
                                {
                                    billingData.type === "tenant" ? (
                                    
                                            <Col>
                                                <Row>{window.tenant_signatories}</Row>
                                                <Row>AMBRE Property Partners</Row>
                                            </Col>
                                    ) : (
                                            <Col>
                                                <Row className='text-sm'>{window.owner_signatories}</Row>
                                                <Row className='text-sm'>Billing and Collection</Row>
                                            </Col>
                                    )
                                }
                               </Row>
                            </Col>
                            <Col span={12} className='p-2'>
                                
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className='btn-footer'>
                    <Space className='mb-4 me-4'>
                    
                        <Button
                            onClick={() => navigate('/parking-billing')}
                            className='cancel-color btn-header'
                        >
                            Cancel
                        </Button>
                    
                        <Button
                           onClick={() => handleSendEmail('preview')}
                           className='secondary-btn btn-header'
                           loading={loading}
                        >
                            Send to Email
                        </Button>
                    
                        <Button
                            onClick={handlePrint}
                            type='primary'
                            className='btn-header'
                        >
                            Print
                        </Button>
                    </Space>
                </Row>
                <Row>
                    <Col span={24} className='p-4'>
                        Billing Attachment
                    </Col>
                </Row>
                <Row className='mx-4'>
                    <Col span={24}>
                        <Table 
                            columns={columns3} 
                            dataSource={billingAttachment} 
                            pagination={false}
                            loading={{
                                indicator: customSpinner,
                                spinning: isLoading,
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={24} className='p-4'>
                        Expense Attachment
                    </Col>
                </Row>
                <Row className='mx-4'>
                    <Col span={24}>
                        <Table 
                            columns={columns3} 
                            dataSource={newAttachment} 
                            pagination={false}
                            loading={{
                                indicator: customSpinner,
                                spinning: isLoading,
                            }}
                        />
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default PreviewBilling
